import { jsx as _jsx } from "react/jsx-runtime";
import Skeleton from "@/components/skeleton";
export default function Loading(param) {
    let {} = param;
    return /*#__PURE__*/ _jsx(Skeleton, {
        className: 'w-full h-full'
    });
}
